import { useTheme } from "@app/app/hooks/useTheme";
import { cn } from "@app/componentLibrary/lib/utils";
import { Text } from "@app/componentLibrary/ui/text";
import { TextProps } from "@app/componentLibrary/ui/text/Text/Text";
import React from "react";

export interface IThemeTextProps extends TextProps {}

export const ThemeText: React.FC<IThemeTextProps> = React.forwardRef<HTMLParagraphElement, IThemeTextProps>(
    ({ children, className, ...textProps }, ref) => {
        const { theme } = useTheme();
        const themeOverrides = theme.overrides?.title["base"];

        return (
            <Text className={cn(className, themeOverrides?.className)} {...textProps}>
                {children}
            </Text>
        );
    }
);

ThemeText.displayName = "ThemeText";
